module.exports = __webpack_public_path__ + "img/2-1.bd0caf11.png";